import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Are chair lifts suitable for all stair types?",
    a: "Yes. We provide solutions for straight, curved, and outdoor staircases. Our experts assess your staircase dimensions and design a custom solution that fits perfectly.",
  },
  {
    q: "How long does installation take?",
    a: "Most installations are completed within 1-2 days. Our certified technicians handle everything with minimal disruption to your home.",
  },
  {
    q: "Can the chair lift be used during a power outage?",
    a: "Absolutely. All our chair lifts come with a reliable battery backup to ensure continuous operation even during power cuts.",
  },
  {
    q: "What is the maximum weight capacity?",
    a: "Our models typically support weights ranging from 120 kg to 160 kg, depending on the configuration. We'll recommend the best option for your needs.",
  },
  {
    q: "Is it safe for elderly or mobility-challenged users?",
    a: "Yes. Chair lifts come with seat belts, obstruction sensors, and emergency stop features to provide maximum safety and peace of mind.",
  },
  {
    q: "Does Vingrace offer EMI or financing options?",
    a: "Yes, we offer easy EMI and financing options to make mobility solutions more accessible and budget-friendly. Contact our team to learn about available plans.",
  },
  {
    q: "Do you offer warranty and after-sales service?",
    a: "Yes, all our products come with a warranty and full after-sales service, including regular maintenance and repair support.",
  },
];

export default function FAQ() {
  return (
    <section data-testid="faq-section" className="py-16 sm:py-20 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-teal-700 mb-3 text-center">Got Questions?</p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-stone-900 text-center font-['Outfit']">
          Frequently Asked Questions
        </h2>

        <div className="mt-10">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-xl border border-stone-200 px-5 overflow-hidden"
              >
                <AccordionTrigger className="text-left text-sm sm:text-base font-medium text-stone-800 hover:text-teal-700 py-4 hover:no-underline">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-stone-500 text-sm leading-relaxed pb-4">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
